import React, { useState } from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import { Link } from 'react-router-dom';

const AssessmentTestResult = () => {
  const [activeTab, setActiveTab] = useState("feedback");

  const renderSummary = () => {
    switch (activeTab) {
      case "feedback":
        return `"Unable to generate feedback due to an error."`;
      case "strengths":
        return `"No strengths identified in this attempt."`;
      case "weaknesses":
        return `"Review concepts related to the questions answered incorrectly."`;
      case "suggestions":
        return `"Practice more MCQs and revise study material."`;
      default:
        return null;
    }
  };

  return (
    <AdminAppBody
      content={
        <div className="container py-4">
          {/* Heading */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="fw-bold">Assessment Result</h4>
             <Link to="/assessments-questions">
            <button className="btn btn-primary text-white rounded">View Questions</button>
            </Link>
          </div>

          {/* Result Summary Box */}
          <div className="border rounded p-4 mb-4 shadow-sm bg-white">
            <div className="row text-center">
              <div className="col-md-2 d-flex flex-column align-items-center justify-content-center">
                <div className="rounded-circle border border-3 p-3">
                  <h5 className="text-danger fw-bold m-0">0%</h5>
                </div>
                <div className="mt-2 fw-bold">Overall Score</div>
              </div>
              <div className="col-md-2 d-flex flex-column align-items-center justify-content-center">
                <h5 className="text-primary m-0">0</h5>
                <div className="text-muted">Correct Answers</div>
              </div>
              <div className="col-md-2 d-flex flex-column align-items-center justify-content-center">
                <h5 className="text-danger m-0">10</h5>
                <div className="text-muted">Wrong Answers</div>
              </div>
              <div className="col-md-3 d-flex flex-column align-items-center justify-content-center">
                <h5 className="text-primary m-0">10</h5>
                <div className="text-muted">Attempted Questions</div>
              </div>
              <div className="col-md-3 d-flex flex-column align-items-center justify-content-center">
                <h5 className="text-primary m-0">10</h5>
                <div className="text-muted">Total Questions</div>
              </div>
            </div>
          </div>

          {/* Feedback Buttons */}
          <div className="d-flex flex-column flex-md-row p-2 justify-content-around">
            <button
              className={`w-100 m-1 border border-primary rounded ${activeTab === 'feedback' ? 'bg-primary text-white' : 'bg-white'}`}
              onClick={() => setActiveTab("feedback")}
            >
              <i className="bi bi-chat-dots me-1" /> Feedback
            </button>
            <button
              className={`w-100 m-1 border border-primary rounded ${activeTab === 'strengths' ? 'bg-primary text-white' : 'bg-white'}`}
              onClick={() => setActiveTab("strengths")}
            >
              <i className="bi bi-arrow-up-right-circle me-1" /> Strengths
            </button>
            <button
              className={`w-100 m-1 border border-primary rounded ${activeTab === 'weaknesses' ? 'bg-primary text-white' : 'bg-white'}`}
              onClick={() => setActiveTab("weaknesses")}
            >
              <i className="bi bi-arrow-down-right-circle me-1" /> Weaknesses
            </button>
            <button
              className={`w-100 m-1 border border-primary rounded ${activeTab === 'suggestions' ? 'bg-primary text-white' : 'bg-white'}`}
              onClick={() => setActiveTab("suggestions")}
            >
              <i className="bi bi-lightbulb me-1" /> Suggestions
            </button>
          </div>

          {/* Feedback Summary Box */}
          <div className="border mt-4 rounded bg-white shadow-sm">
            <div className="p-3 border-bottom fw-bold text-capitalize">{activeTab} Summary</div>
            <div className="p-3">
              <p>{renderSummary()}</p>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AssessmentTestResult;
